module.exports = __webpack_public_path__ + "static/media/top_consumer_reviews_2020.ec915b9c.png";